import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Store, select } from '@ngrx/store';
import { IAppState } from 'src/app/store/state/app.state';
import {selectCID, selectTrackGA} from 'src/app/store/selectors/page.selectors';
import { LoggerService } from '../log4ts/logger.service';
import { MonitoringService } from '../utility/monitoring/monitoring.service';
import {Angulartics2GoogleGlobalSiteTag} from 'angulartics2';
import {IRace} from '../../models/race.interface';
import {BetType} from '../utility/constant/bettype';
import {IRaceResult} from '../../models/raceresult';
import {ISco} from '../../models/sco.interface';
import {INextrace} from '../../models/nextrace.interface';
declare let ga: Function;
@Injectable({
  providedIn: 'root',
})

export class GoogleAnalyticsService {
  private missingGaCount = 0;

  private readonly logging = environment!.google!.analytics!.logging;

  private readonly isActive: boolean = environment!.google!.analytics!.active;

  private UAId = '';
  private cID = '';

  private subscription: Subscription;

  public trackGA$: Observable<string>;
  public pageCID$: Observable<string>;

  betType: typeof BetType = BetType;

  constructor(
    private router: Router,
    private _store: Store<IAppState>,
    private console: LoggerService,
    private monitoringService: MonitoringService,
    public angulartics2: Angulartics2GoogleGlobalSiteTag
  ) {
    this.trackGA$ = this._store.pipe(select(selectTrackGA));
    this.trackGA$.subscribe((x) => (this.UAId = x));
    this.pageCID$ = this._store.pipe(select(selectCID));
    this.pageCID$.subscribe((x) => (this.cID = x));
  }

  /**
   * Track an event with your custom data in google analytics
   * -
   * @param category Typically the object that was interacted with (e.g. 'Video')
   * @param label The type of interaction (e.g. 'play')
   * @param [action=null] Useful for categorizing events (e.g. 'Fall Campaign')
   * @param [value=null] A numeric value associated with the event (e.g. 42)
   */
  // public trackEvent(category: string, label: string, action: string = null, value: number = null) {
  //   try {
  //     if (this.isActive) {
  //       ga('send', 'event', {
  //         eventCategory: category,
  //         eventLabel: label,
  //         eventAction: action,
  //         eventValue: value,
  //       });
  //     }
  //   } catch (error) {
  //     if (this.logging && this.logging.exceptions) {
  //       this.console.error(`error: ${error}`);
  //     }
  //   }
  //
  //   // testing
  //   if (this.logging && this.logging.debug) {
  //     this.console.log(category, label, action, value);
  //   }
  // }
  //
  // public subscribe() {
  //   if (!this.subscription) {
  //     this.subscription = this.router.events.subscribe((e) => {
  //       if (e instanceof NavigationEnd) {
  //         try {
  //           if (this.isActive && this.UAId.length > 0) {
  //             if (e.urlAfterRedirects && this.isOkToLog(e.urlAfterRedirects)) {
  //               // ga should be available directly via the @types/google.analytics
  //               // but I'm still having a problem with it, compile time seems to be good
  //               // but then runtime fails, using (<any>window) to access it.
  //               // if someone knows the reason why please let me know
  //               if ((<any>window).ga) {
  //                 (<any>window).ga('create', `${this.UAId}`, 'auto');
  //                 (<any>window).ga('set', 'page', e.urlAfterRedirects);
  //                 (<any>window).ga('send', 'pageview');
  //               } else {
  //                 // it appears that (<any>window).ga isn't available right away
  //                 // typically fails on the first call, so we're giving it some slack with this.missGaCount
  //                 // we may also want to check for headless environment (e.g. AOT or testers running w/o the window object)
  //                 if (this.logging && this.logging.exceptions && this.missingGaCount > 1) {
  //                   this.console.error(`can't find <any>window).ga`);
  //                 }
  //
  //                 // mark that we've been through this
  //                 this.missingGaCount++;
  //               }
  //             }
  //
  //             if (this.logging && this.logging.debug) {
  //               this.console.log(`logging: ${e.urlAfterRedirects} to google analytics`);
  //             }
  //           } else {
  //             if (this.logging && this.logging.debug) {
  //               this.console.log(`logging not enabled: ${e.urlAfterRedirects} to google analytics`);
  //             }
  //           }
  //         } catch (ex) {
  //           if (this.logging && this.logging.exceptions) {
  //             this.console.error(ex);
  //             this.console.error(`tracking failed - make sure you installed the scripts`);
  //           }
  //         }
  //       }
  //     });
  //   }
  // }
  //
  // public unsubscribe() {
  //   if (this.subscription) {
  //     // --- clear our observable subscription
  //     this.subscription.unsubscribe();
  //   }
  // }
  //
  // private isOkToLog(url: string): boolean {
  //   if (url.toString().indexOf('auth/token') !== -1) {
  //     if (this.logging && this.logging.verbose) {
  //       this.console.log(`don't track ${url}`);
  //     }
  //     return false;
  //   }
  //
  //   if (this.logging && this.logging.verbose) {
  //     this.console.log(`track ${url}`);
  //   }
  //
  //   return true;
  // }

  public initGoogleTag() {
    if (this.UAId && this.UAId !== '' && environment.google.ciD.includes(this.cID)) {
      const tagUrl = 'https://www.googletagmanager.com/gtag/js?id=' + this.UAId;
      this.monitoringService.createScript(tagUrl);
      (<any>window).gtag('js', new Date());
      (<any>window).gtag('config', this.UAId);
    }
  }

  private trackEventGlobalTag(action: string, params: any) {
    // console.log(this.cID !== '' && environment.google.ciD.includes(this.cID));
    // console.log(this.cID);
    // console.log(environment.google.ciD.includes(this.cID));
    if ( this.cID !== '' && environment.google.ciD.includes(this.cID)) {
      this.angulartics2.eventTrack(action, params);
    }
  }

  public eventViewRace(race: IRace) {
    const paramsGA = {
      category: 'Races',
      label: race.country + '-' + race.number + '-' + race.course,
      gstCustom: {
        country: race.country,
        number: race.number,
        course: race.course,
        date: race.date,
        status: race.pers.ss,
        type: race.tp
      }
    };
    this.trackEventGlobalTag('view_race', paramsGA);
  }

  public eventTypeBetsRace(race: IRace, bet) {
    const paramsGA = {
      category: 'Races',
      label: this.betType[bet],
      gstCustom: {
        country: race.country,
        number: race.number,
        course: race.course,
        date: race.date,
        status: race.pers.ss,
        type: race.tp
      }
    };
    this.trackEventGlobalTag('click_race_bet_type', paramsGA);
  }

  public eventOpenStatsHorse(race: IRace, horse) {
    const paramsGA = {
      category: 'Horses',
      label: horse,
      gstCustom: {
        country: race.country,
        number: race.number,
        course: race.course,
        date: race.date,
        status: race.pers.ss,
        type: race.tp
      }
    };
    this.trackEventGlobalTag('click_open_stats_horse', paramsGA);
  }

  public eventClickLastRace(race: IRaceResult) {
    const paramsGA = {
      category: 'Races',
      label: race.country + '-' + race.number + '-' + race.meeting,
      gstCustom: {
        country: race.country,
        number: race.number,
        course: race.meeting,
        date: race.date,
        status: race.ss,
        type: race.tp
      }
    };
    this.trackEventGlobalTag('click_last_race', paramsGA);
  }

  public eventClickLastMinuteRace(race: INextrace) {
    const paramsGA = {
      category: 'Races',
      label: race.country + '-' + race.number + '-' + race.meeting,
      gstCustom: {
        country: race.country,
        number: race.number,
        course: race.meeting,
        date: race.date,
        status: race.ss,
        type: race.tp
      }
    };
    this.trackEventGlobalTag('click_last_minute_race', paramsGA);
  }

  public eventClickTabRace(label) {
    const paramsGA = {
      category: 'Races',
      label: label
    };
    this.trackEventGlobalTag('click_view_tab_race', paramsGA);
  }

  public eventClickBet(sco: ISco) {
    const paramsGA = {
      category: 'Bets',
      label: this.betType[sco.cod],
      gstCustom: {
        number: sco.extra.numCors,
        course: sco.extra.nomCors,
        date: sco.extra.oraCors,
        type: sco.extra.speciality,
        race: sco.race
      }
    };
    this.trackEventGlobalTag('bet_race', paramsGA);
  }

}
